import Guid from "./Guid";
import IModel from "./IModel";

export enum PlanEnteteParametre {
	Type = 0,
	DescriptionFr = 1,
	DescriptionEn = 2,
	DatesDebutFin = 3,
	Unite = 4,
	NbAdultes = 5,
	NbEnfants = 6,
	Duree = 7,
	JoursSemaine = 8,
	TranchesAge = 9,
	CategorieClient = 10,
	AutantEnfantsQueAdultes = 11,
	StatutResident = 12,
	StatutMembre = 13,
	TypeEquipement = 14,
	MontantHebergementTaxable = 15
}

export default interface IPlanEnteteParametreRequis extends IModel {
	idPlanEnteteParametreRequis?: Guid,
	idPlanEntete: Guid,
	requis: boolean,
	parametre: PlanEnteteParametre,
	idAuxiliaire?: Guid,
	typeAuxiliaire?: string,
}